"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lottieWeb = require("lottie-web");

var _lottieWeb2 = _interopRequireDefault(_lottieWeb);

var _lottie_api = require("lottie-api/dist/lottie_api");

var _lottie_api2 = _interopRequireDefault(_lottie_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Lottie = function (_React$Component) {
  (0, _inherits3.default)(Lottie, _React$Component);

  function Lottie() {
    (0, _classCallCheck3.default)(this, Lottie);
    return (0, _possibleConstructorReturn3.default)(this, (Lottie.__proto__ || (0, _getPrototypeOf2.default)(Lottie)).apply(this, arguments));
  }

  (0, _createClass3.default)(Lottie, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          options = _props.options,
          eventListeners = _props.eventListeners;
      var loop = options.loop,
          autoplay = options.autoplay,
          animationData = options.animationData,
          path = options.path,
          _options$renderer = options.renderer,
          renderer = _options$renderer === undefined ? "svg" : _options$renderer,
          rendererSettings = options.rendererSettings,
          assetsPath = options.assetsPath;


      this.options = {
        container: this.el,
        path: path,
        renderer: renderer,
        loop: loop !== false,
        autoplay: autoplay !== false,
        animationData: animationData,
        rendererSettings: rendererSettings,
        assetsPath: assetsPath
      };

      this.options = (0, _extends3.default)({}, this.options, options);

      this.anim = _lottieWeb2.default.loadAnimation(this.options);
      this.setSpeed();
      this.setDirection();
      this.animApi = _lottie_api2.default.createAnimationApi(this.anim);
      this.registerEvents(eventListeners);
      this.setAnimationControl();

      if (this.props.isStopped) {
        this.stop();
      } else if (this.props.segments) {
        this.playSegments(true);
      } else {
        this.play();
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps /* , nextState */) {
      /* Recreate the animation handle if the data is changed */
      if (this.options.animationData !== nextProps.options.animationData) {
        this.deRegisterEvents(this.props.eventListeners);
        this.destroy();
        this.options = (0, _extends3.default)({}, this.options, nextProps.options);
        this.anim = _lottieWeb2.default.loadAnimation(this.options);
        this.animApi = _lottie_api2.default.createAnimationApi(this.anim);
        this.registerEvents(nextProps.eventListeners);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.options.loop !== undefined) {
        this.anim.loop = this.props.options.loop;
      }

      if (this.props.isStopped) {
        this.stop();
      } else if (this.props.segments) {
        if ((0, _stringify2.default)(this.props.segments) === (0, _stringify2.default)(prevProps.segments)) {
          return;
        }
        this.playSegments(this.props.forceSegments);
      } else {
        this.play();
      }

      this.setAnimationControl();
      this.pause();
      this.setSpeed();
      this.setDirection();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.deRegisterEvents(this.props.eventListeners);
      this.destroy();
      this.options.animationData = null;
      this.anim = null;
      this.animApi = null;
    }
  }, {
    key: "setSpeed",
    value: function setSpeed() {
      this.anim.setSpeed(this.props.speed);
    }
  }, {
    key: "setDirection",
    value: function setDirection() {
      this.anim.setDirection(this.props.direction);
    }
  }, {
    key: "setAnimationControl",
    value: function setAnimationControl() {
      var _this2 = this;

      var animationControl = this.props.animationControl;

      if (animationControl) {
        var properties = (0, _keys2.default)(animationControl);

        properties.forEach(function (property) {
          var propertyPath = _this2.animApi.getKeyPath(property);
          var value = animationControl[property];
          _this2.animApi.addValueCallback(propertyPath, function () {
            return value;
          });
        });
      }
    }
  }, {
    key: "play",
    value: function play() {
      this.anim.play();
    }
  }, {
    key: "playSegments",
    value: function playSegments(shouldForce) {
      this.anim.playSegments(this.props.segments, shouldForce);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.anim.stop();
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.props.isPaused && !this.anim.isPaused) {
        this.anim.pause();
      } else if (!this.props.isPaused && this.anim.isPaused) {
        this.anim.pause();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.anim.destroy();
    }
  }, {
    key: "registerEvents",
    value: function registerEvents(eventListeners) {
      var _this3 = this;

      eventListeners.forEach(function (eventListener) {
        _this3.anim.addEventListener(eventListener.eventName, function () {
          eventListener.callback(this.props.title);
        });
      });
    }
  }, {
    key: "deRegisterEvents",
    value: function deRegisterEvents(eventListeners) {
      var _this4 = this;

      eventListeners.forEach(function (eventListener) {
        _this4.anim.removeEventListener(eventListener.eventName, eventListener.callback);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _props2 = this.props,
          width = _props2.width,
          height = _props2.height,
          ariaRole = _props2.ariaRole,
          ariaLabel = _props2.ariaLabel,
          title = _props2.title,
          tabIndex = _props2.tabIndex;


      var getSize = function getSize(initial) {
        var size = void 0;

        if (typeof initial === "number") {
          size = initial + "px";
        } else {
          size = initial || "100%";
        }

        return size;
      };

      var lottieStyles = (0, _extends3.default)({
        width: getSize(width),
        height: getSize(height),
        overflow: "hidden",
        margin: "0 auto",
        outline: "none"
      }, this.props.style);

      return (
        // Bug with eslint rules https://github.com/airbnb/javascript/issues/1374
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        _react2.default.createElement("div", {
          ref: function ref(c) {
            _this5.el = c;
          },
          className: this.props.className,
          style: lottieStyles,
          title: title,
          role: ariaRole,
          "aria-label": ariaLabel,
          tabIndex: tabIndex
        })
      );
    }
  }]);
  return Lottie;
}(_react2.default.Component);

exports.default = Lottie;


Lottie.propTypes = {
  eventListeners: _propTypes2.default.arrayOf(_propTypes2.default.object),
  options: _propTypes2.default.object.isRequired,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  isStopped: _propTypes2.default.bool,
  isPaused: _propTypes2.default.bool,
  speed: _propTypes2.default.number,
  segments: _propTypes2.default.arrayOf(_propTypes2.default.number),
  forceSegments: _propTypes2.default.bool,
  direction: _propTypes2.default.number,
  ariaRole: _propTypes2.default.string,
  ariaLabel: _propTypes2.default.string,
  title: _propTypes2.default.string,
  style: _propTypes2.default.string,
  className: _propTypes2.default.string,
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
};

Lottie.defaultProps = {
  eventListeners: [],
  isStopped: false,
  isPaused: false,
  speed: 1,
  ariaRole: "button",
  ariaLabel: "animation",
  title: "",
  tabIndex: 0,
  className: ""
};